export const SITE = {
  name: 'nextcake',
  brandName: 'Nextcake',
  tagline: 'Магазин товаров для кондитеров в Волгограде',
  phone: '8 (905) 398-17-75',
  email: 'info@nextcake.ru',
  announcement: 'Товары для кондитеров в Волгограде',
  address: 'г. Волгоград, ул. 8-й Воздушной Армии, 14',
  addressLocality: 'Волгоград',
  addressRegion: 'Волгоградская область',
  streetAddress: 'ул. 8-й Воздушной Армии, 14',
  district: 'район Семь Ветров, Дзержинский район',
  mapsUrl: 'https://yandex.ru/maps/-/CTFuVAk1',
  mapsOrgUrl: 'https://yandex.ru/maps/org/nextcake/117591841671/',
  yandexOrgId: '117591841671',
  geo: {
    latitude: 48.749173,
    longitude: 44.507866,
  },
  hours: 'Ежедневно 10:00 – 20:00',
  openingHoursSpec: [
    {
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '10:00',
      closes: '20:00',
    },
  ],
  city: 'Волгоград',
  url: 'https://nextcake.ru',
  description:
    'Магазин nextcake в Волгограде — всё для домашних кондитеров и любителей выпечки: посыпки, топперы, шоколад, формы, красители и декор для тортов. Более 3400 товаров в наличии. Самовывоз и доставка по Волгограду.',
  legalName: 'ИП Пудовкина М. А.',
  vkUrl: 'https://vk.com/nextcake',
  yandexRatingBadgeUrl:
    'https://yandex.ru/sprav/widget/rating-badge/117591841671?type=rating',
  defaultOgImage: '/logo.png',
};
